var map = {
	"./Auth/ConfirmPassword.vue": 9476,
	"./Auth/ForgotPassword.vue": 3668,
	"./Auth/Login.vue": 8167,
	"./Auth/Register.vue": 8853,
	"./Auth/ResetPassword.vue": 6267,
	"./Auth/VerifyEmail.vue": 8938,
	"./CreateTemplate.vue": 7872,
	"./Dashboard.vue": 5995,
	"./Homepage/NewIconListHeader.vue": 9636,
	"./Homepage/cards/Features.vue": 4988,
	"./Homepage/cards/Footer.vue": 2575,
	"./Homepage/cards/IconGalleryMini.vue": 8493,
	"./Homepage/cards/Navigation.vue": 299,
	"./Homepage/cards/SlideRepositoryMini.vue": 2612,
	"./Homepage/homepage.vue": 9672,
	"./Homepage/homepageV2.vue": 1625,
	"./Homepage/limitedUseAgreement.vue": 570,
	"./Homepage/privacyPolicy.vue": 1393,
	"./Homepage/termsOfService.vue": 9204,
	"./Homepage/test_form_to_dd.vue": 9264,
	"./IconGallery.vue": 9414,
	"./Preview.vue": 7773,
	"./Pricing.vue": 2606,
	"./ProcessIcons.vue": 6629,
	"./Profile.vue": 7728,
	"./RootGallery.vue": 5487,
	"./SlideRepo/CollectionSelect.vue": 3782,
	"./SlideRepo/EmptyState.vue": 4257,
	"./SlideRepo/HandleRedirectToActiveCollection.vue": 5788,
	"./SlideRepo/Modals/AddNewCollection.vue": 7607,
	"./SlideRepo/Modals/AddNewSlide.vue": 8946,
	"./SlideRepo/Modals/AddNewSlide_OLD.vue": 9615,
	"./SlideRepo/Modals/GeneratePresentationModal.vue": 4215,
	"./SlideRepo/Modals/ProcessPendingSlides.vue": 4718,
	"./SlideRepo/SettingsCard.vue": 7374,
	"./SlideRepo/SetupFAQs.vue": 8910,
	"./SlideRepo/SetupGuide.vue": 1185,
	"./SlideRepo/SetupGuideDashboard.vue": 7612,
	"./SlideRepo/SlideGallery.vue": 5114,
	"./SlideRepo/SlideRepository.vue": 4378,
	"./TeamManagement/JoinFromCode.vue": 1939,
	"./TeamManagement/TeamManagement.vue": 5556,
	"./TeamManagement/VerifyTeamJoin.vue": 1841,
	"./TemplateGallery.vue": 121,
	"./Welcome.vue": 9983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6634;